module.exports = __webpack_public_path__ + "img/stonks.1b92dfad.svg";